import React, { memo, useMemo } from 'react'
import ShipmentsNeedingAttentionCard from './ShipmentsNeedingAttentionCard'
import { useShipmentsMissingInfoCountsQuery } from './graphql/ShipmentsMissingInfoCounts'

export interface IShipmentsNeedingAttentionSectionProps {}

const ShipmentsNeedingAttentionSection = memo<IShipmentsNeedingAttentionSectionProps>(() => {
  const { data, loading } = useShipmentsMissingInfoCountsQuery({ fetchPolicy: 'cache-and-network' })
  const { shipmentsMissingInfo } = data || {}
  const { itemizedCount, totalCount = 0 } = shipmentsMissingInfo || {}
  const { missingEta = 0, totalMissingAssignments = 0, totalMissingDocuments = 0 } =
    itemizedCount || {}

  const showCard = useMemo(() => {
    if (loading) {
      return true
    }
    return totalCount > 0
  }, [loading, totalCount])

  return showCard ? (
    <ShipmentsNeedingAttentionCard
      totalCount={totalCount}
      missingAssignmentCount={totalMissingAssignments}
      missingEtaCount={missingEta}
      missingDocsCount={totalMissingDocuments}
      loading={loading}
    />
  ) : null
})

export default ShipmentsNeedingAttentionSection
